var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHealthCare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1662602800380,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 81218,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M649.997 241.329c-258.667-40-390 92.001-390.667 92.001-271.333 236 40.667 411.333 40.667 411.999 222 122.666 470.669 26.667 469.335 25.334 172.666-55.333 218.667-200 218.667-200s19.333 2.666 21.001 0.666c-8.999 42.666-32.856 82.761-29.001 76.667-64 103.333-206.667 230-516.667 222.667S47.999 642.665 47.999 642.665s-112-123.998 35.333-295.998 396.001-176.667 401.334-174S653.333 156 816 238.667s193 230.667 193 230.667h-25c-89.33-209.996-336.669-228.005-334.003-228.005zM677.5 718h101l63-401h-94M476 334c-116.5 40.5-108 107.5-108.5 105 31.5 80 37 40.5 116 129.5s-21.5 112-22 112c-77.5 9.5-120.5-5-120.5-5l-37.5-8V729s37 6 40.5 6 161.5 17 232.5-8 87.5-80.5 89-117-32.5-77.5-45.5-81.5-68.5-44.5-68.5-44.5-53.5-41-20-82.5 180-42.5 180-42.5l-3-42c-121-16.5-234 19-232.5 17z",
    "p-id": 81219,
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthCare);
export default __webpack_public_path__ + "static/media/healthCare.5adf58c5.svg";
export { ForwardRef as ReactComponent };